import { useCancelTransactionMutation } from "Api/Mutations/Transactions/useCancelTransactionMutation";
import { useTransactionInitiate } from "Hooks/useTransactionInitiate";
import type { InitiateTransactionRequest } from "Infrastructure/Api/Api";
import { toast } from "sonner";
import { useResource } from "Translations/Resources";
import { getTransactionErrorMessage } from "Utils/TransactionErrorsUtils";

type Result = {
  isPending: boolean;
  mutate: (
    originalTransactionPublicID: string,
    newTransaction: InitiateTransactionRequest,
  ) => void;
};

export const useReplaceExistingTransactionMutation = (): Result => {
  const { t } = useResource();

  const { mutate: replaceTransaction, isPending: isCancelTransactionPending } =
    useCancelTransactionMutation();

  const {
    mutate: initiateTransaction,
    isPending: isInitiateTransactionPending,
  } = useTransactionInitiate({
    onError: (error) => {
      const message = getTransactionErrorMessage(error, t);
      toast.error(message);
    },
  });

  return {
    mutate: (
      originalTransactionPublicID: string,
      transaction: InitiateTransactionRequest,
    ) =>
      replaceTransaction(originalTransactionPublicID, {
        onSuccess: () => initiateTransaction(transaction),
      }),
    isPending: isCancelTransactionPending || isInitiateTransactionPending,
  };
};
